export const PURCHASE_ORDER_LOADED = "Purchase_Order_Loaded";
export const GOOD_RECEIVE_NOTE_LOADED = "Goods_Receive_Note_Loaded";
export const FORECAST_ORDER_LOADED = "Forecast_Order_Loaded";
export const INVOICE_LOADED = "Invoice_Loaded";
export const REJECTED_QC_LOADED = "Rejected_QC_Loaded"
export const REJECTED_QC_FOR_PO_LOADED = "Rejected_QC_For_PO_Loaded"
export const TODO_TASK_LOAD = "Todo_task_loaded"
export const LATESTACTION_UPDATED = "Latest_Action_Updated";
export const NOTIFICATION_LOADED = "Notification_Loaded"
export const NOTIFICATION_READED = "Notification_Readed"
export const REJECTED_QC_HISTORY = "Rejected_QC_History"
export const GET_GENERATED_INVOICES = "Get_Generated_Invoices"
export const GET_COMPLETED_INVOICES = "Get_Completed_Invoices"